import React, { useReducer, useRef } from 'react';
import styles from './News.module.scss';
import reducer from './news-reducer';
import { newsData, suggestionsData } from '../../data';
import NewsItem from '../news-item/NewsItem';
import { CgSearch } from 'react-icons/cg';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

const initialState = {
  news: newsData,
  sortOption: '',
  searchText: '',
  showLiked: false,
};

const News = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <main className={styles.newsContainer}>
      <h1>News and Announcements</h1>
      <div className={styles.filterSort}>
        <section className={styles.cardContainer}>
          <CgSearch className={styles.searchIcn} />
          <input
            placeholder='Start typing to search'
            className={styles.filterInput}
            value={state.searchText}
            onChange={(event) =>
              dispatch({ type: 'SEARCH_TEXT_CHANGE', payload: event })
            }
          />
          <p
            className={
              state.showLiked
                ? `${styles.like}  ${styles.likeSelected}`
                : `${styles.like}`
            }
            onClick={() => dispatch({ type: 'TOGGLE_LIKE' })}
          >
            Liked
          </p>
          <div className={styles.search}>Search</div>
        </section>
        <FormControl className={styles.sort} variant='outlined'>
          <InputLabel id='demo-simple-select-outlined-label'>
            Sort By:
          </InputLabel>
          <Select
            labelId='demo-simple-select-outlined-label'
            id='demo-simple-select-outlined'
            value={state.sortOption}
            label='Sort By:'
            onChange={(event) =>
              dispatch({ type: 'SORT_OPTION_CHANGE', payload: event })
            }
          >
            <MenuItem value={'relevance'}>Relevance</MenuItem>
            <MenuItem value={'date'}>Date</MenuItem>
            <MenuItem value={'menu'}>Likes</MenuItem>
          </Select>
        </FormControl>
      </div>
      {/* <ul className='filter-list'>
        {state.suggestions.map((item) => {
          return (
            <li
              onClick={() =>
                dispatch({ type: 'SUGGESTION_SELECTED', payload: item })
              }
              className='list-item'
              key={item.id}
            >
              {item.name}
            </li>
          );
        })}
      </ul>
      <ul>
        {state.selectedFilters.map((item) => {
          return (
            <li key={item.id}>
              {item.name}
              <button
                onClick={() =>
                  dispatch({ type: 'SUGGESTION_REMOVED', payload: item })
                }
              >
                Remove
              </button>
            </li>
          );
        })}
      </ul> */}
      <article className={styles.newsItems}>
        {state.news.map((item) => {
          return <NewsItem key={item.id} {...item} />;
        })}
      </article>
    </main>
  );
};

export default News;
